export class OrderBySpecs {
  field: string;
  direction?: "asc" | "desc" | "" = "asc";
}